import { Action } from 'redux';
import { EventFamily } from '../entities';

export enum TPlaylistMw {
  SET_PLAYLIST_MW = 'SET_PLAYLIST_MW',
  FETCH_PLAYLIST_MW = 'FETCH_PLAYLIST_MW',
}

export interface ISetPlaylistMw extends Action {
  type: TPlaylistMw.SET_PLAYLIST_MW;
  payload: EventFamily[];
}

export const ASetPlaylistMw = (payload: EventFamily[]): ISetPlaylistMw => ({ type: TPlaylistMw.SET_PLAYLIST_MW, payload });

export interface IFetchPlaylistMw extends Action {
  type: TPlaylistMw.FETCH_PLAYLIST_MW;
}
export const AFetchPlaylistMw = (): IFetchPlaylistMw => ({ type: TPlaylistMw.FETCH_PLAYLIST_MW });
